var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: {
        tabindex: "-1",
        "aria-labelledby": "confirmAction",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h5",
              {
                staticClass: "modal-title",
                attrs: { id: "exampleModalLabel" },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("translate")("Edit")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn-close",
              attrs: {
                type: "button",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "mb-3" }, [
              _c(
                "label",
                {
                  staticClass: "form-label",
                  attrs: { for: `post_title_${_vm.post.id}` },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("translate")("Title")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.post.title,
                    expression: "post.title",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "title",
                  id: `post_title_${_vm.post.id}`,
                },
                domProps: { value: _vm.post.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.post, "title", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-3" }, [
              _c(
                "label",
                {
                  staticClass: "form-label",
                  attrs: { for: `post_body_${_vm.post.id}` },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("translate")("Content")) +
                      "\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.post.body,
                    expression: "post.body",
                  },
                ],
                staticClass: "form-control",
                attrs: { name: "content", id: `post_body_${_vm.post.id}` },
                domProps: { value: _vm.post.body },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.post, "body", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm.showVideoUpload
              ? _c("div", { staticClass: "mb-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.post.video,
                        expression: "post.video",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "video-url",
                      name: "",
                      type: "text",
                      placeholder: "Embed url (Vimeo, YouTube)",
                    },
                    domProps: { value: _vm.post.video },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.post, "video", $event.target.value)
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _vm.showVideoUpload
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-link btn-sm",
                      on: { click: _vm.toggleVideoUpload },
                    },
                    [
                      _vm.showVideoUpload
                        ? _c("i", { staticClass: "fas fa-times" })
                        : _c("i", { staticClass: "far fa-play-circle" }),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-bs-dismiss": "modal" },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("translate")("Cancel")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: ["btn", "btn-primary", _vm.isValid ? "" : "disabled"],
                attrs: { type: "button" },
                on: { click: _vm.save },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("translate")("Save")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }